import { Component, Input } from '@angular/core';
import { AuthService, DatasourceService } from '@app/core/services';
import { BaseListComponent } from './base-list.component';
import { State, aggregateBy, AggregateResult } from "@progress/kendo-data-query";
import { IntlService } from '@progress/kendo-angular-intl';


@Component({
  selector: 'services-list-by-status',
  template: `
  <kendo-grid [style.height.%]="100" [data]="view | async">
    
    <ng-template kendoGridNoRecordsTemplate>
      Sin registros.
    </ng-template>

    <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        # {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>    
    <kendo-grid-column field="output_date" title="Fecha y hora de salida" width="190">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
        <kendo-grid-cell-date [text]="dataItem.output_date" [time]="true"></kendo-grid-cell-date>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="place" title="Destino"></kendo-grid-column>
    <kendo-grid-column field="crane_name" title="Grúa" width="250"></kendo-grid-column>    
    <kendo-grid-column field="person_operator_name" title="Operador" width="250"></kendo-grid-column>   

  </kendo-grid>
  `,
  styles: [``],
  providers:  [ DatasourceService ]
})
export class ServicesListByStatusComponent extends BaseListComponent {

  //Variables

  protected table: string = 'services_inventories';

  //Input: range
  public _range = { start: '', end: '' };

  @Input()
  set range(range: any) {
    this._range = range;

    let that = this;
    this.state = this.getInitialState();
    this.service.pagination(this.table, this.state, function(result, table, state){
      console.log(result, table, state);
      // that.visible = result.data.length;
      // that.total = aggregateBy(result.data, [
      //   { field: "cost", aggregate: "sum" }
      // ]);  
      
      // if(Object.keys(that.total).length === 0) 
      //   that.total = {cost: {sum: 0}};

      that.resultChange.emit({name: `SERVICES_BY_STATUS_${that.service_status}`, result: result, sum: 0});

    })    
  }

  get range(): any { return this._range; }  

  @Input() service_status : string = '';

  @Input() view_date: boolean = true;

  public total: AggregateResult;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected intl: IntlService) {

    super(authService, service, intl);
    // console.log(this.range);

  }

  //Overrides
  protected getInitialState() : State {

    console.log('SERVICE_ESTATUS:', this.service_status);
    let s : State = {
      skip: 0, 
      take: 0, 
      sort: [      
        {field: 'output_date', dir: 'desc'}
      ], 
      filter: {
        logic: "and",
        filters: [               
          // {
          //   field: 'entry_date',
          //   operator: 'inrange',
          //   value: `${this._range.start} 00:00:00,${this._range.end} 23:59:59`
          // },
          {
            field: 'id_service_status',
            operator: 'in',
            value: this.service_status
          }
        ]
      }, 
      group: []
    }

    return s;

  }
  
}
